<template>
  <div class="previewImage" v-show="isPreview" @click="close">
    <div class="centet-box">
      <img v-if="type == 'img'" :src="targetImg" alt />

      <swiper v-else :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <img :src="item.img" alt />
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

import "swiper/dist/css/swiper.css";
export default {
  props: ["isPreview", "clickedIndex", "list", "targetImg", "type"],
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        // loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
    changeCur() {
      this.$nextTick(() => {
        this.swiper.slideTo(this.clickedIndex, 0, false);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.previewImage {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: 200;
  box-sizing: border-box;

  /deep/ .swiper-wrapper {
    display: flex;
    align-items: center;
  }

  .centet-box {
    position: absolute;
    top: 50%;
    transform: translate(0px, -50%);
    display: flex;
    align-items: center;
    width: 100%;
    // height: 500px;
  }
  img {
    width: 100%;
    max-height: 90%;
  }
}
</style>
